import { getCurrentInstance, onUnmounted } from 'vue';
import { claimFieldScope, releaseFieldScope } from './useUiScope';

export const useFieldScope = (label: () => string | undefined): ((event: FocusEvent) => void) => {
    const owner = getCurrentInstance()?.uid;

    onUnmounted(() => {
        if (owner !== undefined) {
            releaseFieldScope(owner);
        }
    });

    return (event: FocusEvent): void => {
        const current = label();
        if (!current || owner === undefined) {
            return;
        }
        event.stopPropagation();
        claimFieldScope(owner, current);
    };
};
